import {
    Avatar,
    Box,
    Card,
    CardContent,
    Tabs,
    Typography,
} from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

const Styled = {
    Card: styled(Card)(({ theme }) => {
        return {
            height: '100%',
            position: 'relative',
            borderRadius: theme.spacing(2.5),
        };
    }),
    AvatarWrapper: styled(Box)(({ theme }) => {
        return {
            '&:before': {
                content: '""',
                display: 'block',
                backgroundColor: theme.palette.background.light,
                padding: '30px',
            },
        };
    }),
    Avatar: styled(Avatar)(({ theme }) => {
        return {
            border: `1px solid ${theme.palette.background.paper}`,
            top: '-40px',
            left: '12px',
            width: '54px',
            height: '54px',
            zIndex: 3,
        };
    }),
    CardContent: styled(CardContent)(({ theme }) => {
        return {
            backgroundColor: theme.palette.background.paper,
            borderRadius: '20px',
            zIndex: 2,
            marginTop: '-70px',
            paddingTop: '33px',
            height: '100%',
        };
    }),
    CardButton: styled(Box)(({ theme }) => {
        return {
            borderRadius: '100px',
            height: 'fit-content',
            backgroundColor: theme.palette.background.default,
            svg: {
                color: theme.palette.text.primary,
            },
        };
    }),

    TabsContainer: styled(Box)(() => {
        return {
            display: 'flex',
            alignItems: 'center',
        };
    }),
    Select: styled(Box)(() => {
        return {};
    }),
    Tabs: styled(Tabs)(({ theme }) => {
        return {
            backgroundColor:
                theme.palette.mode === 'dark'
                    ? alpha(theme.palette.common.white, 0.035)
                    : alpha(theme.palette.primary.main, 0.055),
            borderRadius: '11px',
            padding: '3px',
            minHeight: '38px',
            maxWidth: '100%',
            '& .MuiTabs-flexContainer': {
                gap: '3px',
            },
            button: {
                borderRadius: '8px',
                padding: '5px 12px',
                minHeight: '32px',
                minWidth: 'auto',
                color: theme.palette.text.secondary,
                transition: 'background-color .16s ease, color .16s ease',

                '&.Mui-selected': {
                    backgroundColor:
                        theme.palette.mode === 'dark'
                            ? alpha(theme.palette.primary.light, 0.16)
                            : alpha(theme.palette.primary.main, 0.12),
                    color:
                        theme.palette.mode === 'dark'
                            ? theme.palette.primary.light
                            : theme.palette.primary.dark,
                    fontWeight: 700,
                    boxShadow:
                        theme.palette.mode === 'light'
                            ? `0 3px 10px ${alpha(theme.palette.primary.main, 0.1)}`
                            : `0 3px 10px ${alpha(theme.palette.common.black, 0.16)}`,
                },
            },
            '.MuiTabs-indicator': {
                display: 'none',
            },
        };
    }),
    NavigatorIcon: styled(Box)(({ theme }) => {
        return {
            background: theme.palette.primary.main,
            backgroundImage: theme.palette.gradientButton.base,
            padding: theme.spacing(2),
            borderRadius: theme.spacing(1),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: theme.spacing(2),

            [theme.breakpoints.up('md')]: {
                marginRight: theme.spacing(3),
            },

            i: {
                fontSize: theme.typography.h1,
                color: theme.palette.text.secondary,
            },
        };
    }),
    NavigatorDesciptionWrapper: styled(Box)(() => {
        return {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            textAlign: 'start',
        };
    }),
    NavigatorLabel: styled(Typography)(({ theme }) => {
        return {
            fontSize: '17px',
            [theme.breakpoints.up('sm')]: {
                fontSize: '24px',
            },
            fontFamily: 'YekanBalkhHeavy',
        };
    }),
    NavigatorDesciption: styled(Box)(({ theme }) => {
        return {
            position: 'relative',
            fontSize: '11px',

            [theme.breakpoints.up('sm')]: {
                fontSize: '13px',
            },
        };
    }),
};

export { Styled };
